import React from 'react';
import Navbar from '../components/Navbar';
import { Rocket, Clock, Users, DollarSign } from 'lucide-react';

const LaunchpadPage = () => {
    return (
        <div className="bg-[#0b0e11] min-h-screen text-white font-sans selection:bg-orange-500/30">
            <Navbar />

            {/* Hero */}
            <div className="relative py-20 px-4 text-center overflow-hidden">
                <div className="absolute top-0 left-0 w-full h-full bg-orange-600/10 z-0"></div>
                <div className="relative z-10">
                    <div className="inline-flex items-center justify-center p-4 bg-orange-500/20 rounded-full mb-6 text-orange-500">
                        <Rocket size={48} />
                    </div>
                    <h1 className="text-4xl sm:text-6xl font-black mb-6 tracking-tight">Albatech Launchpad</h1>
                    <p className="text-xl text-gray-400 max-w-2xl mx-auto mb-10">
                        Early access to the next generation of blockchain projects. Secure, fair, and carefully vetted.
                    </p>
                    <div className="flex gap-4 justify-center">
                        <button className="bg-orange-600 hover:bg-orange-500 text-white px-8 py-3 rounded-xl font-bold transition shadow-lg shadow-orange-900/20">View Projects</button>
                        <button className="bg-[#181a20] border border-gray-700 text-white px-8 py-3 rounded-xl font-bold hover:bg-gray-800 transition">How it Works</button>
                    </div>
                </div>
            </div>

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
                <h2 className="text-2xl font-bold mb-8">Upcoming Projects</h2>

                {/* Project Card */}
                <div className="bg-[#181a20] rounded-3xl border border-gray-800 overflow-hidden hover:border-orange-500/50 transition group">
                    <div className="h-48 bg-gradient-to-r from-gray-800 to-gray-900 relative">
                        <div className="absolute bottom-0 left-0 p-6 flex items-end translate-y-1/2">
                            <div className="w-24 h-24 bg-black rounded-2xl border-4 border-[#181a20] flex items-center justify-center font-bold text-3xl">
                                G
                            </div>
                        </div>
                        <div className="absolute top-4 right-4 bg-orange-600 text-white px-3 py-1 rounded-lg text-sm font-bold uppercase">
                            Coming Soon
                        </div>
                    </div>

                    <div className="pt-16 pb-8 px-8">
                        <div className="flex justify-between items-start mb-4">
                            <div>
                                <h3 className="text-2xl font-bold text-white mb-2">GameFi Revolution</h3>
                                <p className="text-gray-400 text-sm max-w-md">The ultimate play-to-earn ecosystem connecting gamers and investors.</p>
                            </div>
                            <div className="text-right">
                                <div className="text-gray-500 text-sm">Total Raise</div>
                                <div className="text-2xl font-bold text-orange-500">$500,000</div>
                            </div>
                        </div>

                        <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 mt-8 p-6 bg-[#0b0e11] rounded-2xl border border-gray-800">
                            <div>
                                <div className="text-gray-500 text-xs mb-1">Token Price</div>
                                <div className="font-bold text-white">0.05 USDT</div>
                            </div>
                            <div>
                                <div className="text-gray-500 text-xs mb-1">Total Supply</div>
                                <div className="font-bold text-white">100M GFR</div>
                            </div>
                            <div>
                                <div className="text-gray-500 text-xs mb-1">Hard Cap</div>
                                <div className="font-bold text-white">$500k</div>
                            </div>
                            <div>
                                <div className="text-gray-500 text-xs mb-1">Access</div>
                                <div className="font-bold text-white">Public</div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mt-12 text-center">
                    <p className="text-gray-500">More projects coming soon...</p>
                </div>
            </div>
        </div>
    );
};

export default LaunchpadPage;
